module.exports = __webpack_public_path__ + "img/food_04.901063e9.jpg";